import React, { useEffect, useState, useRef } from 'react';
import { Avatar, Box, Button, Grid, Checkbox, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Geocode from "react-geocode";
import { AddCircle, CameraAltRounded, RemoveCircle, LocationOn, Close } from '@mui/icons-material';
import CropFreeIcon from '@mui/icons-material/CropFree';
import Check from '@mui/icons-material/Check';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import moment from 'moment';
import useServices from '../../services/useServices';
import { beep, getOS, getSessionData, setSessionData, updateManifestFile } from '../../utils/utils';
import MapServices from '../../services/MapServices';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import AddressPicker from '../../components/AddressPicker';
import GoogleMapReact from 'google-map-react';
import imageCompression from 'browser-image-compression';
import AutoComplete from '../../components/GoogleMaps/Autocomplete';
import DialogComponent from '../../components/DialogComponent';
import InputMultipleValuesWithChip from '../../components/InputMultipleValuesWithChip';
import ImageUploader from '../../components/ImageUploader';
import Scanner from '../../components/Scanner/Scanner';
import FormSubmissionHandler from './FormSubmissionHandler'
import LocationPermissionDialog from './LocationPermissionDialog'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY);
Geocode.enableDebug();

const requestPageStyles = makeStyles({
    labelName: { fontWeight: "600", marginBottom: "8px" },
    valueStyle: { marginBottom: "15px !important" },
    captureStyle: { color: "black", fontSize: "2.5rem !important" },
    avatar: { height: "100px !important", width: "200px !important" },
    requestButton: {
        backgroundColor: "green",
        '&:hover': { backgroundColor: "green" }
    },
    buttonStyle: { color: "black" }
});

const NewRequest = () => {
    const classes = requestPageStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const { screen: screenParam } = useParams();
    const accountId = getSessionData('userID');
    const uniqueCode = getSessionData('token');
    updateManifestFile(accountId, uniqueCode);
    const [profilePics, setProfilePics] = useState([]);
    const [thumbnailImgs, setThumbnailImgs] = useState([]);
    const [towCount, setTowCount] = useState(1);
    const [truckCount, setTruckCount] = useState(1);
    const [screen, setScreen] = useState(1);
    const [userData, setUserData] = useState({});
    const [mapApi, setMapApi] = useState(null);
    const [mapInstance, setMapInstance] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [scanData, setScanData] = useState(null);
    const [stopStream, setStopStream] = useState(false);
    const [isGpsEnabled, setIsGpsEnabled] = useState(false);
    const [openScanner, setOpenScanner] = useState(false);
    const [list, setList] = useState([]);
    const [checked, setChecked] = useState(false);
    const [isSelected, setSelected] = useState(false);
    const [pickupLocationDetails, setPickupLocationDetails] = useState({
        addressLine: "", area: "", city: "", state: "", postalCode: "", landmark: ""
    });
    const [formData, setFormData] = useState({ pickUpAddress: "", dropOffAddress: "" });
    const [pickupLocation, setPickupLocation] = useState([0, 0]);
    const { post } = useServices();

    const [note, setNote] = useState("");
    const [openNoteDialog, setOpenNoteDialog] = useState(false);
    const [savedNote, setSavedNote] = useState(""); // State to store the saved note
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    // Add this with your other useState declarations
    const [showLocationAlert, setShowLocationAlert] = useState(false);
    // Add new state for API message returned resource
    const [responseMessage, setResponseMessage] = useState("");


    // Add this new function
    const handlePermissionRetry = () => {
        // Try to clear cached permissions
        if (navigator.permissions && navigator.permissions.revoke) {
            navigator.permissions.revoke({ name: 'geolocation' })
                .then(() => {
                    setShowLocationAlert(false);
                    window.location.reload();
                })
                .catch(() => {
                    window.location.reload();
                });
        } else {
            window.location.reload();
        }
    };
    // Open dialog for adding/editing notes
    const handleOpenNoteDialog = () => {
        setOpenNoteDialog(true);
    };

    // Close the dialog
    const handleCloseNoteDialog = () => {
        setOpenNoteDialog(false);
    };

    // Save note and close dialog
    const handleSaveNote = () => {
        if (note.trim()) {
            setSavedNote(note); // Save note to state for display
            setOpenNoteDialog(false); // Close the dialog
        } else {
            console.warn("Note is empty, please add some content.");
        }
    };

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const mapRef = useRef(null);
    const markerRef = useRef(null);
    useEffect(() => {
        const data = getSessionData("userData") || JSON.stringify({});
        setUserData(JSON.parse(data));
    }, []);

    // Function to handle map and marker updates
    const updateMapAndMarker = (lat, lng) => {
        if (mapRef.current && markerRef.current) {
            mapRef.current.panTo({ lat, lng });
            markerRef.current.setPosition({ lat, lng });
            setPickupLocation([lat, lng]);
        }
    };

    useEffect(() => {
        if (pickupLocationDetails.addressLine && pickupLocationDetails.city && pickupLocationDetails.state) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    }, [pickupLocationDetails]);

    useEffect(() => {
        if (mapApi && pickupLocation.length === 2 && !isSelected) {
            fetchAddressFromGeocode();
        }
    }, [mapApi, pickupLocation]);

    const handleCapture = async ({ target }) => {
        const files = Array.from(target.files);
        const newProfilePics = [...profilePics];
        const newThumbnailImgs = [...thumbnailImgs];

        for (const file of files) {
            const size = getFileSize(file.size);
            if (size > 1) {
                const compressedFile = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1920 });
                newProfilePics.push(compressedFile);
                newThumbnailImgs.push(URL.createObjectURL(compressedFile));
            } else {
                newProfilePics.push(file);
                newThumbnailImgs.push(URL.createObjectURL(file));
            }
        }

        setProfilePics(newProfilePics);
        setThumbnailImgs(newThumbnailImgs);
    };

    // const handleCapture = async ({ target }) => {
    //     const files = Array.from(target.files);
    //     const newProfilePics = [...profilePics];
    //     const newThumbnailImgs = [...thumbnailImgs];

    //     for (const file of files) {
    //         const size = getFileSize(file.size);
    //         if (size > 1) {
    //             const compressedFile = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1920 });
    //             newProfilePics.push(compressedFile);
    //             newThumbnailImgs.push(URL.createObjectURL(compressedFile));
    //         } else {
    //             newProfilePics.push(file);
    //             newThumbnailImgs.push(URL.createObjectURL(file));
    //         }
    //     }

    //     setProfilePics(newProfilePics);
    //     setThumbnailImgs(newThumbnailImgs);
    // };

    const getFileSize = (_size) => {
        const cnvertSizeTOMB = _size / 1048576; //mb
        return cnvertSizeTOMB;
    };

    const removeTowingCount = () => {
        if (towCount > 1) setTowCount(towCount - 1);
        setTruckCount(1);
    };

    const addTowingCount = () => {
        setTowCount(towCount + 1);
    };

    const removeTruckCount = () => {
        if (truckCount > 1) setTruckCount(truckCount - 1);
    };

    const addTruckCount = () => {
        if (towCount > truckCount) setTruckCount(truckCount + 1);
    };
    // Replace your current location-related useEffect
    useEffect(() => {
        const requestLocation = () => {
            if (!navigator.geolocation) {
                setShowLocationAlert(true);
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setIsGpsEnabled(true);
                    setPickupLocation([latitude, longitude]);
                    if (mapRef.current) {
                        mapRef.current.panTo({ lat: latitude, lng: longitude });
                        if (markerRef.current) {
                            markerRef.current.setPosition({ lat: latitude, lng: longitude });
                        }
                    }
                    setShowLocationAlert(false);
                },
                (error) => {
                    console.warn(`ERROR(${error.code}): ${error.message}`);
                    setIsGpsEnabled(false);
                    setShowLocationAlert(true);
                    // Set default location or last known location if available
                    const defaultLat = 40.7128;
                    const defaultLng = -74.0060;
                    setPickupLocation([defaultLat, defaultLng]);
                    if (mapRef.current) {
                        mapRef.current.panTo({ lat: defaultLat, lng: defaultLng });
                        if (markerRef.current) {
                            markerRef.current.setPosition({ lat: defaultLat, lng: defaultLng });
                        }
                    }
                },
                { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
            );
        };

        requestLocation();
    }, []);
    const onChangeHandler = (e, key) => {
        formData[key] = e.target.value;
        setFormData({ ...formData });
    };

    const getBase64 = (files) => {
        if (!Array.isArray(files)) files = [files];

        const promises = files.map(file => {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    resolve(reader.result);
                };
                reader.onerror = function (error) {
                    reject(error);
                };
            });
        });

        return Promise.all(promises);
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const userID = getSessionData("userID")
            const token = getSessionData("token")

            if (userID) {
                const base64Array = await getBase64(profilePics);
                const VIN = list.filter(item => item.isValid).map(item => item.value)
                const fileType = profilePics && profilePics.length > 0 && profilePics[0].type ? profilePics[0].type.split("/")[1] : null;
                const deviceId = localStorage.getItem('fcm_token');
                const requestBody = {
                    receiverDate: moment().format("MM/DD/YYYY"),
                    pickupAddrLine1: pickupLocationDetails.addressLine,
                    pickupCity: pickupLocationDetails.city,
                    pickupState: pickupLocationDetails.state,
                    pickupZipcode: pickupLocationDetails.postalCode,
                    pickupLandmark: pickupLocationDetails.landmark,
                    pickupLatLong: pickupLocation.join(','),
                    requestTime: moment().format("MM/DD/YYYY HH:mm:ss"),
                    receivedTime: moment().format("MM/DD/YYYY HH:mm:ss"),
                    pic: base64Array,
                    duplicateCopies: towCount,
                    noOfTrucks: truckCount,
                    VIN, securityID: getSessionData("securityID"),
                    "isGpsEnabled": isGpsEnabled,
                    deviceId: deviceId||getSessionData("uniqueDeviceId"),
                    savedNote: savedNote,
                }
                const res = await post(`newservicecall/directCall/${userID}/${token}/${checked}`, requestBody)
                // Set response message from API response which includes the invoice ID
                setResponseMessage(res.data.message);
                setTimeout(() => {
                }, 90000); // 90 seconds delay
                setProfilePics([])
                const serviceOrder = res.data.resp.split(',')
                const serviceOrders = getSessionData('serviceOrders')
                const serviceOrdersArray = serviceOrders ? JSON.parse(serviceOrders) : []
                serviceOrdersArray.push(...serviceOrder)
                setSessionData(serviceOrdersArray, 'serviceOrders')
                handleNext()
            } else {
                throw 'user not valid';
            }
        } catch (error) {
            console.log(error);
            setSubmitError('Unable to submit request. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };
    const setFormCoordinates = (lat, lng) => {
        setPickupLocation([lat, lng]);
    };

    const gotoHome = () => {
        navigate("/");
    };

    const gotoTrackOrder = () => {
        navigate("/trackOrder");
    };

    const onChangePickupHandler = (e, key) => {
        pickupLocationDetails[key] = e.target.value;
        setPickupLocationDetails({ ...pickupLocationDetails });
    };

    const getLocationDetails = (locationObj) => {
        setPickupLocation([locationObj.lat, locationObj.lng]);
    };

    useEffect(() => {
        // Push the initial state when the component mounts
        window.history.replaceState({ screen }, '', '');

        const handlePopState = (event) => {
            const newScreen = event.state?.screen;

            if (openScanner) {
                // Close the scanner and do nothing else
                setOpenScanner(false);
                setStopStream(true);
                // We do not modify the history stack here
            } else if (newScreen !== undefined && newScreen > 0) {
                setScreen(newScreen);
            } else {
                // If no valid screen state is found, navigate to the default route (e.g., track order)
                navigate("/trackOrder");
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate, openScanner, screen]);

    const handleBack = (fromPopState = false) => {
        if (openScanner) {
            // Simply close the scanner
            setOpenScanner(false);
            setStopStream(true);
        } else {
            const newScreen = screen - 1;
            if (newScreen >= 1) {
                setScreen(newScreen);
                if (!fromPopState) {
                    // Replace the state to ensure the history remains consistent
                    window.history.replaceState({ screen: newScreen }, '', '');
                }
            } else {
                navigate("/trackOrder");
            }
        }
    };

    const handleNext = () => {
        const newScreen = screen + 1;
        setScreen(newScreen);
        // Push a new state only when moving forward
        window.history.pushState({ screen: newScreen }, '', '');
    };


    const updateFormStateData = (results) => {
        if (results) {
            let addressArray = results.address_components,
                addressLine = MapServices.getAddressLine(addressArray) || '',
                postalCode = MapServices.getPostalCode(addressArray) || '',
                city = MapServices.getCity(addressArray) || '',
                area = MapServices.getArea(addressArray) || '',
                state = MapServices.getState(addressArray) || '';
            if (!addressLine) {
                addressLine = results.formatted_address.split(',')[0];
            }
            setFormData({ ...formData, pickUpAddress: `${area},${city},${state}` });
            setPickupLocationDetails({ addressLine, area, city, state, postalCode, landmark: "" });
        }
    };

    const fetchAddressFromGeocode = () => {
        const geocoder = new mapApi.Geocoder();
        geocoder.geocode({ 'location': { lat: pickupLocation[0], lng: pickupLocation[1] } }, (results, status) => {
            if (status === 'OK') {
                updateFormStateData(results[0]);
                setSelected(true);
            }
        });
    };
    const AddressHelper = {
        safeGetAddressComponents(addressComponents = []) {
            try {
                // Extract all route components (streets)
                const routes = addressComponents.filter(comp =>
                    comp.types.includes('route') ||
                    comp.types.includes('intersection')
                );

                // Extract any cardinal directions
                const directions = addressComponents.filter(comp =>
                    comp.long_name.match(/^(N|S|E|W|NE|NW|SE|SW)(\s|$)/)
                );

                return { routes, directions };
            } catch (e) {
                console.debug('Error extracting components:', e);
                return { routes: [], directions: [] };
            }
        },

        handleIntersection(formattedAddress = '', addressComponents = []) {
            try {
                // Check if it's definitely an intersection
                const isIntersection =
                    formattedAddress.toLowerCase().includes(' and ') ||
                    formattedAddress.toLowerCase().includes(' & ') ||
                    addressComponents.some(comp => comp.types.includes('intersection'));

                if (!isIntersection) return null;

                // Get street components
                const { routes, directions } = this.safeGetAddressComponents(addressComponents);

                // If we have at least two streets
                if (routes.length >= 2) {
                    const street1 = routes[0].long_name;
                    const street2 = routes[1].long_name;

                    // Ensure cardinal directions are included
                    const direction1 = street1.match(/^(N|S|E|W|NE|NW|SE|SW)(\s|$)/) ? street1 :
                        directions[0]?.long_name ? `${directions[0].long_name} ${street1}` : street1;

                    const direction2 = street2.match(/^(N|S|E|W|NE|NW|SE|SW)(\s|$)/) ? street2 :
                        directions[1]?.long_name ? `${directions[1].long_name} ${street2}` : street2;

                    return `Intersection of ${direction1} and ${direction2}`;
                }

                // Fallback to formatted address if it contains intersection info
                if (isIntersection && formattedAddress) {
                    return formattedAddress;
                }

                return null;
            } catch (e) {
                console.debug('Error handling intersection:', e);
                return null;
            }
        },

        enhanceAddressLine(originalAddress, addressComponents = [], formattedAddress = '') {
            try {
                // First, try to handle as intersection
                const intersectionAddress = this.handleIntersection(formattedAddress, addressComponents);
                if (intersectionAddress) {
                    return intersectionAddress;
                }

                // If not an intersection, keep original or enhance normal address
                let enhancedAddress = originalAddress;

                if (!originalAddress || originalAddress.trim().length < 3) {
                    const { routes, directions } = this.safeGetAddressComponents(addressComponents);

                    if (routes.length > 0) {
                        const streetName = routes[0].long_name;
                        const direction = directions[0]?.long_name || '';

                        // Include cardinal direction if available
                        enhancedAddress = direction ?
                            `${direction} ${streetName}` : streetName;
                    } else {
                        enhancedAddress = formattedAddress || originalAddress;
                    }
                }

                return enhancedAddress || originalAddress || '';
            } catch (e) {
                console.debug('Error enhancing address:', e);
                return originalAddress || '';
            }
        }
    };

    const fetchAddressOnPointerChange = async (lat, lng) => {
        const geocoder = new mapApi.Geocoder();
        
        try {
            // First try at exact location
            const result = await new Promise((resolve) => {
                geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                    if (status === 'OK' && results && results[0]) {
                        resolve(results[0]);
                    } else {
                        resolve(null);
                    }
                });
            });
    
            if (result) {
                // Extract just the street address components
                const streetNumber = result.address_components.find(comp => 
                    comp.types.includes('street_number')
                )?.long_name || '';
    
                const streetName = result.address_components.find(comp => 
                    comp.types.includes('route')
                )?.long_name || '';
    
                // Check if we have a complete street address
                if (streetNumber && streetName) {
                    setPickupLocationDetails({
                        addressLine: `${streetNumber} ${streetName}`,
                        area: MapServices.getArea(result.address_components) || '',
                        city: MapServices.getCity(result.address_components) || '',
                        state: MapServices.getState(result.address_components) || '',
                        postalCode: MapServices.getPostalCode(result.address_components) || '',
                        landmark: ''
                    });
                    return;
                }
    
                // Handle intersection case
                const streets = result.address_components.filter(comp => 
                    comp.types.includes('route')
                );
    
                if (streets.length === 1) {
                    const radius = 10;
                    const nearbyResult = await new Promise((resolve) => {
                        geocoder.geocode({
                            location: { lat, lng },
                            radius: radius
                        }, (results, status) => {
                            if (status === 'OK' && results) {
                                resolve(results);
                            } else {
                                resolve([]);
                            }
                        });
                    });
    
                    const nearbyStreets = new Set();
                    nearbyResult.forEach(place => {
                        place.address_components
                            .filter(comp => comp.types.includes('route'))
                            .forEach(street => nearbyStreets.add(street.long_name));
                    });
    
                    const streetArray = Array.from(nearbyStreets);
                    if (streetArray.length >= 2) {
                        setPickupLocationDetails({
                            addressLine: `Intersection of ${streetArray[0]} and ${streetArray[1]}`,
                            area: MapServices.getArea(result.address_components) || '',
                            city: MapServices.getCity(result.address_components) || '',
                            state: MapServices.getState(result.address_components) || '',
                            postalCode: MapServices.getPostalCode(result.address_components) || '',
                            landmark: ''
                        });
                        return;
                    }
                }
    
                // If we get here, extract just the first line of the formatted address
                // by splitting on the first comma and taking the first part
                const firstLine = result.formatted_address.split(',')[0];
                setPickupLocationDetails({
                    addressLine: firstLine,
                    area: MapServices.getArea(result.address_components) || '',
                    city: MapServices.getCity(result.address_components) || '',
                    state: MapServices.getState(result.address_components) || '',
                    postalCode: MapServices.getPostalCode(result.address_components) || '',
                    landmark: ''
                });
            } else {
                setPickupLocationDetails({
                    addressLine: 'Address not found',
                    area: '',
                    city: '',
                    state: '',
                    postalCode: '',
                    landmark: ''
                });
            }
        } catch (error) {
            console.error('Error fetching address:', error);
            setPickupLocationDetails({
                addressLine: 'Error finding address',
                area: '',
                city: '',
                state: '',
                postalCode: '',
                landmark: ''
            });
        }
    };

    const apiHasLoaded = (map, maps) => {
        setMapApi(maps);
        setMapInstance(map);
        mapRef.current = map;

        // Create and set the marker
        markerRef.current = new maps.Marker({
            position: { lat: pickupLocation[0], lng: pickupLocation[1] },
            map: mapRef.current,
            draggable: true,
        });

        // Marker drag event
        markerRef.current.addListener('dragend', (event) => {
            const newLat = event.latLng.lat();
            const newLng = event.latLng.lng();
            fetchAddressOnPointerChange(newLat, newLng);
        });
    };

    const addPlace = (place) => {
        setPickupLocation([]);
        setPickupLocation([place.geometry.location.lat() || '', place.geometry.location.lng() || '']);
        updateFormStateData(place);
    };

    function updateList(items) {
        let newList = [].concat(list, items);
        setList(newList);
    }

    function validateValue(value, validatedItems) {
        let isValid = true; // Assume the value is valid by default
        const valueInt = value; // Convert value to an integer
        const selectedValues = list.map((item) => item.value);
        const validatedValues = validatedItems.map((item) => item.value);
        if (selectedValues.indexOf(valueInt) !== -1 || validatedValues.indexOf(valueInt) !== -1) {
            isValid = false; // Set isValid to false if the value already exists
        }
        return isValid;
    }

    function validateInput(event, inputs, reason) {
        if ('createOption' == reason) {
            let id = list.length;
            let validatedItems = [];
            let isValid = validateValue(inputs, validatedItems);
            if (isValid) {
                validatedItems.push({
                    id: ++id,
                    value: inputs,
                    isValid
                });
                updateList(validatedItems);
            }
        } else if ('removeOption' == reason) {
            let listById = {};
            for (let item of list) {
                listById[item.id] = item;
            }

            let newList = inputs.map((id) => listById[id]);
            setList(newList);
        } else if ('clear' == reason) {
            setList([]);
        }
    }

    return (
        <>
            <Box sx={{ flexGrow: 1, paddingLeft: 3, paddingRight: 3, paddingTop: 1, backgroundColor: "#f5f5f5" }}>
                <Grid container>
                    <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>

                        <>
                            <Button variant='contained' fullWidth color='error' onClick={() => gotoTrackOrder()}>
                                Tow Status
                            </Button>
                        </>

                    </Grid>
                    {screen === 1 &&
                        <>
                            <GoogleMapReact
                                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY, libraries: ['places', 'geometry'] }}
                                center={pickupLocation.length ? { lat: pickupLocation[0], lng: pickupLocation[1] } : { lat: 0, lng: 0 }}
                                defaultZoom={12}
                                yesIWantToUseGoogleMapApiInternals
                                onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
                            />
                            <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                <Grid item xs={12}>
                                    {pickupLocation && pickupLocation[0] ? <AddressPicker
                                        lat={pickupLocation[0]}
                                        lng={pickupLocation[1]}
                                        fetchAddressOnPointerChange={(lat, lng) => {
                                            fetchAddressOnPointerChange(lat, lng);
                                            setPickupLocation([lat, lng]);
                                        }}
                                        setFormCoordinates={setFormCoordinates} /> : null}
                                </Grid>
                            </Grid>
                            <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                {savedNote && (
                                    <Grid item xs={12} sx={{ marginBottom: 1 }}>
                                        <Box sx={{
                                            border: "1px solid #1976d2",
                                            borderRadius: "4px",
                                            padding: "10px",
                                            backgroundColor: "#e3f2fd",
                                            color: "#0d47a1"
                                        }}>
                                            <Typography variant="body1" sx={{ fontWeight: "bold" }}>Note:</Typography>
                                            <Typography variant="body2">{savedNote}</Typography>
                                        </Box>
                                    </Grid>
                                )}

                                {/* Button to Open Note Dialog */}
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={handleOpenNoteDialog}
                                    >
                                        {savedNote ? "Edit Note" : "Add Note"}
                                    </Button>
                                </Grid>
                                {/* Note Dialog */}
                                <Dialog open={openNoteDialog} onClose={handleCloseNoteDialog}>
                                    <DialogTitle>{savedNote ? "Edit Note" : "Add Note"}</DialogTitle>
                                    <DialogContent>
                                        <TextField
                                            label="Note"
                                            variant="outlined"
                                            multiline
                                            rows={4}
                                            fullWidth
                                            value={note}
                                            onChange={(e) => setNote(e.target.value)}
                                        />
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleCloseNoteDialog} color="secondary">
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={handleSaveNote}
                                            color="primary"
                                            disabled={!note.trim()} // Disable if note is empty or only whitespace
                                        >
                                            Save
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </Grid>
                            <Grid container alignItems={'center'} item xs={12} sx={{ marginBottom: 1 }} flexDirection={'row'}>
                                <Grid item xs={6}>
                                    <Typography className={classes.labelName} sx={{ marginBottom: "0px !important " }}>Pick Up Location</Typography>
                                </Grid>
                            </Grid>

                            {(mapApi && mapInstance) &&
                                <Grid item xs={12}>
                                    <AutoComplete map={mapInstance} mapApi={mapApi} addplace={addPlace} updatedValue={pickupLocationDetails.addressLine} onChangeHandler={onChangePickupHandler}
                                        fetchAddressOnPointerChange={(lat, lng) => { fetchAddressOnPointerChange(lat, lng); }}
                                        lng={pickupLocation && pickupLocation[1] ? pickupLocation[1] : null}
                                        lat={pickupLocation[0] ? pickupLocation[0] : null} setIsGpsEnabled={(val) => { setIsGpsEnabled(val); }} />
                                </Grid>
                            }


                            <Grid item xs={12}>
                                <TextField
                                    label="additional Info (Optional)"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'landmark'); }}
                                    value={pickupLocationDetails.landmark}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="City"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'city'); }}
                                    value={pickupLocationDetails.city}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="State"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'state'); }}
                                    value={pickupLocationDetails.state}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Postal Code"
                                    variant="outlined"
                                    className={classes.valueStyle}
                                    fullWidth
                                    onChange={(e) => { onChangePickupHandler(e, 'postalCode'); }}
                                    value={pickupLocationDetails.postalCode}
                                />
                            </Grid>
                        </>
                    }
                    {screen === 2 &&
                        <>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}># of Vehicles to Tow</Typography>
                            </Grid>
                            <Grid item xs={8} sx={{ mt: 1 }} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={removeTowingCount}><RemoveCircle /></Button>
                                <Typography className={classes.valueStyle}>{towCount}</Typography>
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={addTowingCount}><AddCircle /></Button>
                            </Grid>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}># of Tow Trucks</Typography>
                            </Grid>
                            <Grid item xs={8} sx={{ mt: 1 }} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={removeTruckCount}><RemoveCircle /></Button>
                                <Typography className={classes.valueStyle}>{truckCount}</Typography>
                                <Button component="span" sx={{ p: 0 }} className={classes.buttonStyle} onClick={addTruckCount}><AddCircle /></Button>
                            </Grid>
                            <Grid item xs={4} sx={{ mt: 1 }}>
                                <Typography className={classes.labelName}>Flatbed Required</Typography>
                            </Grid>
                            <Grid item xs={8} container justifyContent={'flex-end'} alignItems="flex-start">
                                <Checkbox
                                    checked={checked}
                                    onChange={(e) => setChecked(e.target.checked)}
                                    color="primary"
                                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                                    checkedIcon={<Check fontSize="small" />}
                                />
                                <Grid>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Grid>
                            </Grid>
                        </>
                    }
                    {screen === 3 &&
                        <>

                            <Grid container justifyContent={'flex-end'}>
                                <ImageUploader handleCapture={handleCapture} /> {/* Add the ImageUploader component */}
                            </Grid>
                            <Grid item xs={12}>
                                {thumbnailImgs.length > 0 ? (
                                    <Slider {...settings}>
                                        {thumbnailImgs.map((imgURL, index) => (
                                            <Box
                                                key={index}
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                sx={{
                                                    height: { xs: '200px', sm: '250px' },  // Set a fixed height for all slides
                                                    width: '100%',
                                                    overflow: 'hidden' // Ensure images do not overflow
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={imgURL}
                                                    alt={`Thumbnail ${index + 1}`}
                                                    sx={{
                                                        height: '100%',  // Ensures the image fits the container height
                                                        width: 'auto',    // Maintains aspect ratio
                                                        objectFit: 'cover',  // Fill the box while maintaining aspect ratio
                                                        display: 'block',
                                                    }}
                                                />
                                            </Box>
                                        ))}
                                    </Slider>
                                ) : (
                                    <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '250px' }}>
                                        <Avatar variant='square' className={classes.avatar}> {/* Default avatar */}
                                        </Avatar>
                                    </Box>
                                )}
                            </Grid>


                            <Grid item xs={4} sx={{ mt: 1 }}>
                            </Grid>
                            {/* <Grid item xs={8} container justifyContent={'flex-end'}>
                                <Button component="span" onClick={() => {
                                    console.log("Opening scanner");
                                    setOpenScanner(true);
                                    setStopStream(false);
                                }}>
                                    <CropFreeIcon className={classes.captureStyle} />
                                    Scan VIN
                                </Button>
                            </Grid>
                            <DialogComponent open={openScanner} handleClose={() => setOpenScanner(false)}>
                                <Scanner
                                    height='25%'
                                    width={'50%'}
                                    handleScan={(result) => {
                                        if (result) {
                                            const scannedValue = result.codeResult.code;
                                            setScanData(scannedValue);
                                            setStopStream(true);
                                            setOpenScanner(false);
                                            // Check if the scanned value is valid and not a duplicate
                                            const isValid = validateValue(scannedValue, list);
                                            if (isValid) {
                                                const newList = [...list, { id: list.length + 1, value: scannedValue, isValid: true }];
                                                setList(newList);
                                                beep(80, 500, 30);
                                            } else {
                                                beep(200, 700, 50);
                                            }
                                        }
                                    }}
                                />
                            </DialogComponent> */}
                            {/* <Grid item xs={12}><InputMultipleValuesWithChip list={list} validateInput={validateInput} /></Grid> */}
                        </>
                    }
                    {screen === 4 &&
                        <Grid container justifyContent={'center'} alignItems="center" sx={{ minHeight: 300 }}>
                            <Grid m={3} container direction="column" alignItems="center">
                                <Typography>{responseMessage}<br /></Typography>
                                <Button color="secondary" onClick={gotoTrackOrder}>Track Order</Button>
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} sx={{ mt: 10, mb: 3 }}>
                        {screen < 3 &&
                            <Button variant='contained' disabled={!isValid} fullWidth className={classes.requestButton} onClick={handleNext}>
                                Next
                            </Button>
                        }
                        {screen === 3 &&
                            <Button
                                disabled={
                                    // (userData.requiredVin === 1 && (list.length === 0 || list.length < towCount)) ||
                                    profilePics.length === 0
                                }
                                variant='contained'
                                fullWidth
                                className={classes.requestButton}
                                onClick={handleSubmit}
                            >
                                Request Tow
                            </Button>
                           
                        }
                        <br />
                        <br />
                        {screen < 4 &&
                            <>
                                <Button variant='contained' fullWidth color='error' onClick={() => handleBack(false)}>
                                    Back
                                </Button>
                            </>
                        }
                    </Grid>
                </Grid>
            </Box>
            {/* Location Alert Dialog */}
            <LocationPermissionDialog 
                open={showLocationAlert}
                onClose={() => setShowLocationAlert(false)}
                onRetry={handlePermissionRetry}
            />
            <FormSubmissionHandler
                                isSubmitting={isSubmitting}
                                error={submitError}
                                onRetry={handleSubmit}
                                onClose={() => setSubmitError(null)}
                            />
        </>
    );
};

export default NewRequest;
